<gt-main-nav>
  <router-outlet></router-outlet>
</gt-main-nav>
